import * as THREE from "three";

/**
 * A single, shared 3-step gradient map for MeshToonMaterial. Every toon
 * material in the scene reads this same texture so all props band
 * identically (per plan M1b: "a shared 3-step gradientMap ... so all props
 * band identically").
 *
 * NearestFilter keeps the steps crisp instead of interpolating between them,
 * which is what gives the "thick, crisp" cel-shaded look `04-art-direction.md` asks for.
 */
let sharedGradientMap: THREE.DataTexture | null = null;

export function getToonGradientMap(): THREE.DataTexture {
  if (sharedGradientMap) return sharedGradientMap;

  // 3 bands: shadow, mid, highlight. The shadow band is deliberately high —
  // this is a warm, cozy workshop, so unlit faces should stay readable rather
  // than crushing to near-black.
  const bandValues = new Uint8Array([135, 200, 255]);
  const texture = new THREE.DataTexture(bandValues, bandValues.length, 1, THREE.RedFormat);
  texture.minFilter = THREE.NearestFilter;
  texture.magFilter = THREE.NearestFilter;
  texture.generateMipmaps = false;
  texture.needsUpdate = true;

  sharedGradientMap = texture;
  return texture;
}
